module.exports = __webpack_public_path__ + "static/vegas13-5-6d24778ef615950b7e803d2946df9529.jpg";